module["exports"] = [
  "#####"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/sv/address/postcode.js
// module id = 1348
// module chunks = 0